import React, { useEffect, useState } from 'react';
import './CountdownTimer.css';

interface Props {
  targetIso: string;
}

export const CountdownTimer: React.FC<Props> = ({ targetIso }) => {
  const [remaining, setRemaining] = useState(() => calcRemaining(targetIso));

  useEffect(() => {
    setRemaining(calcRemaining(targetIso));
    const id = setInterval(() => setRemaining(calcRemaining(targetIso)), 1000);
    return () => clearInterval(id);
  }, [targetIso]);

  if (remaining <= 0) {
    return (
      <span className="countdown-timer firing" title="O servidor pode levar até ~1 min no próximo disparo agendado">
        Aguardando envio…
      </span>
    );
  }

  const mins = Math.floor(remaining / 60);
  const secs = remaining % 60;
  const display = mins > 0
    ? `${mins}:${String(secs).padStart(2, '0')}`
    : `${secs}s`;

  return <span className="countdown-timer">{display}</span>;
};

function calcRemaining(iso: string): number {
  const diff = Math.floor((new Date(iso).getTime() - Date.now()) / 1000);
  return Math.max(0, diff);
}
